import { Theme, useMediaQuery } from '@mui/material';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default function useIsMobile(breakpoint: number = MOBILE_BREAK_POINT) {
    return useMediaQuery<Theme>((theme) => theme.breakpoints.down(breakpoint));
}
